import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import DefaultLayout from "layouts/default.jsx";

import { Helmet } from 'react-helmet'

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Banner from "components/Banner/Banner.jsx";
import Avatar from '@material-ui/core/Avatar';
import HeroCard from 'components/HeroCard/HeroCard.jsx';

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";

// Sections for this page
import EarlyAdopterCTA from "sections/CTAs/EarlyAdopterCTA.jsx";
import MissingStepCTA from "sections/CTAs/MissingStepCTA.jsx";
import JoinTheMovementCta from "sections/CTAs/JoinTheMovementCTA.jsx";
import OurSharesCTA from "sections/CTAs/OurSharesCTA.jsx";
import YourSharesMyFutureCTA from "sections/CTAs/YourSharesMyFutureCTA.jsx";

//in AboutPage Sections
import BlogSection from "sections/BlogPage/BlogSection.jsx";

import WithDog from "components/Background/WithDog.jsx";
import blogImage from "assets/img/blog.png";

class BlogPage extends React.Component {
  render() {
    const { classes, ...rest } = this.props;
    return (
      <DefaultLayout>
        <Helmet>
          <title>blog | we the shareholders</title>
          <meta property="og:title" content="blog | we the shareholders"/>
          <meta name="twitter:title" content="blog | we the shareholders"/>
          <meta name="description" content="Our story. Our why."/>
          <meta property="og:description" content="Our story. Our why."/>
          <meta name="twitter:description" content="Our story. Our why."/>
          <meta property="og:image" content={`https://wetheshareholders.com${blogImage}`}/>
          <meta name="twitter:image" content={`https://wetheshareholders.com${blogImage}`}/>
          <meta property="og:image:alt" content="A person and their dog jumping in joy set against a colorful sunset."/>
          <meta name="twitter:image:alt" content="A person and their dog jumping in joy set against a colorful sunset."/>
        </Helmet>
        <Banner BackgroundImage={WithDog}>
          <div className={classes.container}>
          </div>
        </Banner>
          <GridContainer alignItems="center">
            <GridItem xs={12}>
              <h2 className={classes.sectionTitle}>Blog</h2>
            </GridItem>
          </GridContainer>
        <div className={classNames(classes.main)}>
          <div>
            <BlogSection/>
            <YourSharesMyFutureCTA  listIds={[19]}/>
          </div>
        </div>
        <Footer />
      </DefaultLayout>
    );
  }
}

export default withStyles(landingPageStyle)(BlogPage);
